import { jwtDecode } from 'jwt-decode';
import { head, last, isObject, get, uniq } from 'lodash-es';
import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var ImpersonationDetails = /*#__PURE__*/function () {
  function ImpersonationDetails(impersonationStack) {
    this.assistModeEnabled = false;
    this.assistModeEnabled = (impersonationStack == null ? void 0 : impersonationStack.length) > 1;
    this.actualUser = head(impersonationStack);
    this.impersonatedUser = last(impersonationStack);
    this.impersonationStack = impersonationStack;
  }
  ImpersonationDetails.fromAuthJwt = function fromAuthJwt(token) {
    var details = !!token && isObject(token) ? get(token, 'http://il/impersonation', null) : null;
    return !!details ? new ImpersonationDetails(details) : null;
  };
  return ImpersonationDetails;
}();

var AuthJwt = /*#__PURE__*/function () {
  function AuthJwt(jwt) {
    var _this = this;
    this.iss = '';
    this.nbf = 0;
    this.iat = 0;
    this.exp = 0;
    this.sid = '';
    this.jti = '';
    this.sub = '';
    this.auth_time = 0;
    this.idp = '';
    this.amr = [];
    this.tenant = '';
    this.tenant_user_id = '';
    this.login_code = '';
    this.client_id = '';
    this.aud = [];
    this.scope = [];
    this.username = '';
    this.name = '';
    this.given_name = '';
    this.family_name = '';
    this.email = '';
    this.organization_id = '';
    this.root_organization_id = '';
    this.root_organization_guid = '';
    this.organization_guid = '';
    this.role = '';
    this['http://il/id'] = '';
    this['http://il/username'] = '';
    this['http://il/sites'] = '';
    this['http://il/env'] = '';
    this['http://il/orgs'] = '';
    this['http://il/orgPaths'] = '';
    this['http://il/products'] = [];
    this['http://il/firstLanguage'] = '';
    this['http://il/writtenLanguage'] = '';
    this['http://il/grade'] = '';
    this['http://il/impersonation'] = [];
    if (jwt) {
      var obj = typeof jwt === 'string' ? jwtDecode(jwt) : jwt;
      Object.keys(obj).forEach(function (key) {
        if (Object.hasOwn(_this, key)) {
          _this[key] = obj[key];
        }
      });
      this.jwt = obj;
    }
  }
  _createClass(AuthJwt, [{
    key: "notValidBefore",
    get: function get() {
      return new Date(this.nbf * 1000);
    }
  }, {
    key: "expires",
    get: function get() {
      return new Date(this.exp * 1000);
    }
  }, {
    key: "authTime",
    get: function get() {
      return new Date(this.auth_time * 1000);
    }
  }, {
    key: "displayName",
    get: function get() {
      var _name = this[AuthJwt.claims.name];
      return (_name == null ? void 0 : _name.length) > 0 ? _name : this[AuthJwt.claims.given_name] + " " + this[AuthJwt.claims.family_name];
    }
  }, {
    key: "id",
    get: function get() {
      return this[AuthJwt.claims.id];
    }
  }, {
    key: "userName",
    get: function get() {
      return this[AuthJwt.claims.username] || this[AuthJwt.claims.il_username];
    }
  }, {
    key: "siteCodes",
    get: function get() {
      return this[AuthJwt.claims.sites];
    }
  }, {
    key: "firstLanguage",
    get: function get() {
      return this[AuthJwt.claims.firstLanguage];
    }
  }, {
    key: "writtenLanguage",
    get: function get() {
      return this[AuthJwt.claims.writtenLanguage];
    }
  }, {
    key: "gradeLevel",
    get: function get() {
      return this[AuthJwt.claims.gradeLevel];
    }
  }, {
    key: "orgPaths",
    get: function get() {
      return this[AuthJwt.claims.orgPaths];
    }
  }, {
    key: "environment",
    get: function get() {
      return this[AuthJwt.claims.env];
    }
  }, {
    key: "organizations",
    get: function get() {
      return this[AuthJwt.claims.orgs];
    }
  }, {
    key: "products",
    get: function get() {
      return this[AuthJwt.claims.products];
    }
  }, {
    key: "impersonation",
    get: function get() {
      return this[AuthJwt.claims.impersonation];
    }
  }, {
    key: "impersonationDetails",
    get: function get() {
      return new ImpersonationDetails(this.impersonation);
    }
  }, {
    key: "impersonationEnabled",
    get: function get() {
      var _this$impersonation;
      return ((_this$impersonation = this.impersonation) == null ? void 0 : _this$impersonation.length) > 1;
    }
  }]);
  return AuthJwt;
}();
AuthJwt.claims = {
  // standard
  sub: 'sub',
  name: 'name',
  email: 'email',
  role: 'role',
  client_id: 'client_id',
  given_name: 'given_name',
  family_name: 'family_name',
  // custom
  id: 'http://il/id',
  username: 'username',
  il_username: 'http://il/username',
  sites: 'http://il/sites',
  firstLanguage: 'http://il/firstLanguage',
  impersonation: 'http://il/impersonation',
  writtenLanguage: 'http://il/writtenLanguage',
  gradeLevel: 'http://il/grade',
  products: 'http://il/products',
  orgPaths: 'http://il/orgPaths',
  orgs: 'http://il/orgs',
  env: 'http://il/env'
};
function getAuthJwt(jwt) {
  return new AuthJwt(jwt);
}

var accessToken = function accessToken() {
  var regex = new RegExp("^oidc.user:(.*)(edgenuity|imaginelearning)", 'i');
  var key = Object.keys(sessionStorage).find(function (key) {
    return regex.test(key);
  });
  if (key) {
    var _JSON$parse, _JSON$parse2;
    var value = sessionStorage.getItem(key);
    var token = value !== null ? (_JSON$parse = JSON.parse(value)) == null ? void 0 : _JSON$parse.access_token : null;
    var expires = value !== null ? (_JSON$parse2 = JSON.parse(value)) == null ? void 0 : _JSON$parse2.expires_at : null;
    var expired = expires !== null && expires <= Date.now() / 1000;
    return expired ? null : token;
  }
  return null;
};
var parsedAccessToken = function parsedAccessToken() {
  var token = accessToken();
  return token ? getAuthJwt(token) : null;
};

var ScopeClaims;
(function (ScopeClaims) {
  ScopeClaims["ActivityFeedApi"] = "ActivityFeedApi";
  ScopeClaims["ArtifactApi"] = "ArtifactApi";
  ScopeClaims["AssessmentApi"] = "AssessmentApi";
  ScopeClaims["AuthApi"] = "AuthApi";
  ScopeClaims["DataGatherApi"] = "DataGatherApi";
  ScopeClaims["DotCMSApi"] = "DotCMSApi";
  ScopeClaims["DynamicAssessmentApi"] = "DynamicAssessmentApi";
  ScopeClaims["GalileoApi"] = "GalileoApi";
  ScopeClaims["GalileoRosterApi"] = "GalileoRosterApi";
  ScopeClaims["GraphCMSApi"] = "GraphCMSApi";
  ScopeClaims["ImportApi"] = "ImportApi";
  ScopeClaims["KvsApi"] = "KvsApi";
  ScopeClaims["LearnosityApi"] = "LearnosityApi";
  ScopeClaims["LoggerApi"] = "LoggerApi";
  ScopeClaims["ManagerApi"] = "ManagerApi";
  ScopeClaims["MathFactsApi"] = "MathFactsApi";
  ScopeClaims["NweaApi"] = "NweaApi";
  ScopeClaims["OpenId"] = "OpenId";
  ScopeClaims["PathfinderApi"] = "PathfinderApi";
  ScopeClaims["PermissionsApi"] = "PermissionsApi";
  ScopeClaims["PlaylistApi"] = "PlaylistApi";
  ScopeClaims["RadApi"] = "RadApi";
  ScopeClaims["RadTailpipeApi"] = "RadTailpipeApi";
  ScopeClaims["ReaderApi"] = "ReaderApi";
  ScopeClaims["RegistrationApi"] = "RegistrationApi";
  ScopeClaims["ReportsApi"] = "ReportsApi";
  ScopeClaims["ReportsCoreApi"] = "ReportsCoreApi";
  ScopeClaims["ReportsMathCoreApi"] = "ReportsMathCoreApi";
  ScopeClaims["ReportsReadingCoreApi"] = "ReportsReadingCoreApi";
  ScopeClaims["RolloverManagerApi"] = "RolloverManagerApi";
  ScopeClaims["RosterApi"] = "RosterApi";
  ScopeClaims["SchedulerApi"] = "SchedulerApi";
  ScopeClaims["SelfhostedAdaptiveApi"] = "SelfhostedAdaptiveApi";
  ScopeClaims["SemaphoreApi"] = "SemaphoreApi";
  ScopeClaims["SequencerApi"] = "SequencerApi";
  ScopeClaims["SettingsApi"] = "SettingsApi";
  ScopeClaims["SisenseApi"] = "SisenseApi";
  ScopeClaims["SpinnakerApi"] = "SpinnakerApi";
  ScopeClaims["StudentDataApi"] = "StudentDataApi";
  ScopeClaims["SuessCDNApi"] = "SuessCDNApi";
  ScopeClaims["TransferApi"] = "TransferApi";
  ScopeClaims["WebReportingApi"] = "WebReportingApi";
})(ScopeClaims || (ScopeClaims = {}));
var ILAuthScopeClaims;
(function (ILAuthScopeClaims) {
  ILAuthScopeClaims["ActivityFeedApi"] = "api.activityfeed";
  ILAuthScopeClaims["ArtifactApi"] = "api.artifact";
  ILAuthScopeClaims["AssessmentApi"] = "api.assessment";
  ILAuthScopeClaims["AuthApi"] = "api.auth";
  ILAuthScopeClaims["DataGatherApi"] = "api.datagather";
  ILAuthScopeClaims["DotCMSApi"] = "api.dotcms";
  ILAuthScopeClaims["DynamicAssessmentApi"] = "api.dynamic.assessment";
  ILAuthScopeClaims["GalileoApi"] = "api.galileo";
  ILAuthScopeClaims["GalileoRosterApi"] = "api.galileo.roster";
  ILAuthScopeClaims["GraphCMSApi"] = "api.graphcms";
  ILAuthScopeClaims["ImportApi"] = "api.import";
  ILAuthScopeClaims["KvsApi"] = "api.kvs";
  ILAuthScopeClaims["LearnosityApi"] = "api.learnosity";
  ILAuthScopeClaims["LoggerApi"] = "api.logger";
  ILAuthScopeClaims["ManagerApi"] = "api.manager";
  ILAuthScopeClaims["MathFactsApi"] = "api.mathfacts";
  ILAuthScopeClaims["NweaApi"] = "api.nwea";
  ILAuthScopeClaims["OpenId"] = "openid";
  ILAuthScopeClaims["PathfinderApi"] = "api.pathfinder";
  ILAuthScopeClaims["PermissionsApi"] = "api.permissions";
  ILAuthScopeClaims["PlaylistApi"] = "api.playlist";
  ILAuthScopeClaims["RadApi"] = "api.rad";
  ILAuthScopeClaims["RadTailpipeApi"] = "api.radtailpipe";
  ILAuthScopeClaims["ReaderApi"] = "api.reader";
  ILAuthScopeClaims["RegistrationApi"] = "api.registration";
  ILAuthScopeClaims["ReportsApi"] = "api.reports";
  ILAuthScopeClaims["ReportsCoreApi"] = "api.reports.core";
  ILAuthScopeClaims["ReportsMathCoreApi"] = "api.reports.math.core";
  ILAuthScopeClaims["ReportsReadingCoreApi"] = "api.reports.reading.core";
  ILAuthScopeClaims["RolloverManagerApi"] = "api.rollover.manager";
  ILAuthScopeClaims["RosterApi"] = "api.roster";
  ILAuthScopeClaims["SchedulerApi"] = "api.scheduler";
  ILAuthScopeClaims["SelfhostedAdaptiveApi"] = "selfhosted-adaptive";
  ILAuthScopeClaims["SemaphoreApi"] = "api.semaphore";
  ILAuthScopeClaims["SequencerApi"] = "api.sequencer";
  ILAuthScopeClaims["SettingsApi"] = "api.settings";
  ILAuthScopeClaims["SisenseApi"] = "api.rad";
  ILAuthScopeClaims["SpinnakerApi"] = "api.spinnaker";
  ILAuthScopeClaims["StudentDataApi"] = "api.studentdata";
  ILAuthScopeClaims["SuessCDNApi"] = "";
  ILAuthScopeClaims["TransferApi"] = "api.transfer";
  ILAuthScopeClaims["WebReportingApi"] = "api.reports"; // Skipping new scope since ILAuth is going away soon
})(ILAuthScopeClaims || (ILAuthScopeClaims = {}));
var IMLPScopeClaims;
(function (IMLPScopeClaims) {
  IMLPScopeClaims["ActivityFeedApi"] = "Scope.IL.Activityfeed";
  IMLPScopeClaims["ArtifactApi"] = "Scope.IL.Artifact";
  IMLPScopeClaims["AssessmentApi"] = "Scope.IL.Assessment";
  IMLPScopeClaims["AuthApi"] = "Scope.IL.Auth";
  IMLPScopeClaims["DataGatherApi"] = "Scope.IL.Datagather";
  IMLPScopeClaims["DotCMSApi"] = "Scope.IL.Dotcms";
  IMLPScopeClaims["DynamicAssessmentApi"] = "Scope.Dynamic.Assessment";
  IMLPScopeClaims["GalileoApi"] = "Scope.Galileo.Api";
  IMLPScopeClaims["GalileoRosterApi"] = "Scope.Galileo.Roster";
  IMLPScopeClaims["GraphCMSApi"] = "Scope.IL.Graphcms";
  IMLPScopeClaims["ImportApi"] = "Scope.IL.Import";
  IMLPScopeClaims["KvsApi"] = "Scope.IL.KVS";
  IMLPScopeClaims["LearnosityApi"] = "Scope.IL.Learnosity Scope.CAT.Learnosity";
  IMLPScopeClaims["LoggerApi"] = "Scope.IL.Logger";
  IMLPScopeClaims["ManagerApi"] = "Scope.IL.Registration";
  IMLPScopeClaims["MathFactsApi"] = "Scope.IL.Mathfacts";
  IMLPScopeClaims["NweaApi"] = "Scope.IL.Nwea";
  IMLPScopeClaims["OpenId"] = "openid";
  IMLPScopeClaims["PathfinderApi"] = "Scope.IL.Pathfinder";
  IMLPScopeClaims["PermissionsApi"] = "Scope.IL.Permissions";
  IMLPScopeClaims["PlaylistApi"] = "Scope.IL.Playlist";
  IMLPScopeClaims["RadApi"] = "Scope.RAD.ClassSummaryDashboard Scope.RAD.UsageReportClasses Scope.RAD.UsageReportStudents";
  IMLPScopeClaims["RadTailpipeApi"] = "Scope.IL.Radtailpipe";
  IMLPScopeClaims["ReaderApi"] = "Scope.IL.Reader";
  IMLPScopeClaims["RegistrationApi"] = "Scope.IL.Registration";
  IMLPScopeClaims["ReportsApi"] = "Scope.IL.Reports";
  IMLPScopeClaims["ReportsCoreApi"] = "Scope.IL.Reports.Core";
  IMLPScopeClaims["ReportsMathCoreApi"] = "Scope.IL.Reports.Math.Core";
  IMLPScopeClaims["RolloverManagerApi"] = "Scope.IL.Rollover.Manager";
  IMLPScopeClaims["RosterApi"] = "Scope.IL.Roster";
  IMLPScopeClaims["SchedulerApi"] = "Scope.Scheduler.Api";
  IMLPScopeClaims["SelfhostedAdaptiveApi"] = "selfhosted-adaptive";
  IMLPScopeClaims["SemaphoreApi"] = "Scope.IL.Semaphore";
  IMLPScopeClaims["SequencerApi"] = "Scope.IL.Sequencer";
  IMLPScopeClaims["SettingsApi"] = "Scope.IL.Settings";
  IMLPScopeClaims["SisenseApi"] = "Scope.Sisense.Tokengenerator";
  IMLPScopeClaims["SpinnakerApi"] = "Scope.IL.Spinnaker";
  IMLPScopeClaims["StudentDataApi"] = "Scope.IL.StudentData";
  IMLPScopeClaims["SuessCDNApi"] = "Scope.IL.Literacy.CDN.Proxy.API";
  IMLPScopeClaims["TransferApi"] = "Scope.IL.Auth.Transfer";
  IMLPScopeClaims["WebReportingApi"] = "Scope.DataInsights.WebReporting.API";
})(IMLPScopeClaims || (IMLPScopeClaims = {}));
function getImlpClaims(claims) {
  return (claims == null ? void 0 : claims.length) > 0 ? uniq(claims.map(function (claim) {
    return IMLPScopeClaims[claim];
  })) : [];
}
function getIlAuthClaims(claims) {
  return (claims == null ? void 0 : claims.length) > 0 ? uniq(claims.map(function (claim) {
    return ILAuthScopeClaims[claim];
  })) : [];
}
function getCombinedClaims(claims) {
  return {
    ILAuthClaims: getIlAuthClaims(claims),
    IMLPAuthClaims: getImlpClaims(claims)
  };
}

var Environment;
(function (Environment) {
  Environment["Development"] = "development";
  Environment["Test"] = "test";
  Environment["Rc"] = "rc";
  Environment["Production"] = "production";
})(Environment || (Environment = {}));
function toEnvironment(environment) {
  var env = environment;
  return !env || !env.length || env.match(/test/gi) ? Environment.Test : env.match(/prod/gi) ? Environment.Production : env.match(/rc/gi) ? Environment.Rc : Environment.Development;
}

var _AUTH_URLS;
var AUTH_URLS = (_AUTH_URLS = {}, _AUTH_URLS[Environment.Development] = {
  imlpApiUrl: 'https://identity.qa.edgenuityapp.com/api',
  ilAuthApiUrl: 'https://testapi.imaginelearning.com'
}, _AUTH_URLS[Environment.Test] = {
  imlpApiUrl: 'https://identity.qa.edgenuityapp.com/api',
  ilAuthApiUrl: 'https://testapi.imaginelearning.com'
}, _AUTH_URLS[Environment.Rc] = {
  imlpApiUrl: 'https://identity.staging.edgenuityapp.com/api',
  ilAuthApiUrl: 'https://rcapi.imaginelearning.com'
}, _AUTH_URLS[Environment.Production] = {
  imlpApiUrl: 'https://identity.app.edgenuity.com/api',
  ilAuthApiUrl: 'https://api.imaginelearning.com'
}, _AUTH_URLS);

function parseUrlPart(queryString) {
  if (!queryString) {
    return {};
  }
  // Replace leading '?'
  var cleanedStr = queryString.replace(/^(\?|#)/, '');
  // Split into individual key-value pairs
  var kvPairs = cleanedStr.split('&');
  return kvPairs.reduce(function (accumulator, kvPairString) {
    var _extends2;
    var index = kvPairString.indexOf('=');
    var key;
    var value = '';
    if (index < 0) {
      key = kvPairString;
    } else {
      key = kvPairString.substring(0, index);
      value = kvPairString.substring(index + 1);
    }
    key = decodeURIComponent(key);
    value = decodeURIComponent(value);
    return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = value, _extends2));
  }, {});
}
function encodeQueryString(queryParts) {
  if (!queryParts) {
    return {};
  }
  var dict = {};
  for (var key in queryParts) {
    var value = queryParts[key];
    var encodedValue = btoa(value);
    dict[key] = encodedValue;
  }
  return dict;
}
var parseQueryString = /*#__PURE__*/parseUrlPart(window.location.search);

var AuthSource;
(function (AuthSource) {
  AuthSource["IMLP"] = "imlp";
  AuthSource["ILAuth"] = "ilauth";
})(AuthSource || (AuthSource = {}));
var AuthenticationManager = /*#__PURE__*/function () {
  function AuthenticationManager(params) {
    this.params = params;
    this.defaultSettings = {
      response_type: 'code',
      loadUserInfo: false,
      userStore: new WebStorageStateStore({
        store: window.sessionStorage
      })
      // clockSkew: 11100 // in seconds (3h 5m). Default is 300s (5m). Token validation should account for client time or timezone being off +/- a few.
    };
    // keeping initialization out of constructor to allow consuming apps to use varying singleton patterns
  }
  var _proto = AuthenticationManager.prototype;
  _proto.checkAuthSourceParam = function checkAuthSourceParam() {
    var _matches$, _matches$2;
    var queryParams = window.location.search;
    var matches = !queryParams ? null : queryParams == null ? void 0 : queryParams.match(/authSource=([^&]*)/);
    return matches === null ? null : matches != null && (_matches$ = matches[1]) != null && _matches$.match(/imlp/gi) ? AuthSource.IMLP : matches != null && (_matches$2 = matches[1]) != null && _matches$2.match(/ilauth/gi) ? AuthSource.ILAuth : null;
  };
  _proto.checkLocalStorage = function checkLocalStorage() {
    var localStorageKeys = Object.keys(localStorage);
    var oidcKeys = localStorageKeys.filter(function (key) {
      return key.match(/^oidc./i);
    });
    if (oidcKeys && oidcKeys.length > 0) {
      var _oidcObj3, _oidcObj4, _oidcObj4$authority, _oidcKey, _oidcObj5, _oidcObj5$authority, _oidcKey2;
      var oidcObj = null;
      var oidcKey = '';
      oidcKeys.forEach(function (key) {
        var _oidcObj2;
        var value = localStorage.getItem(key);
        var _oidcObj = JSON.parse(value);
        if (oidcObj === null || (_oidcObj == null ? void 0 : _oidcObj.created) > ((_oidcObj2 = oidcObj) == null ? void 0 : _oidcObj2.created)) {
          oidcObj = _oidcObj;
          oidcKey = key;
        }
      });
      oidcObj = (_oidcObj3 = oidcObj) != null && _oidcObj3.created ? oidcObj : null;
      return (_oidcObj4 = oidcObj) != null && (_oidcObj4$authority = _oidcObj4.authority) != null && _oidcObj4$authority.match(/edgenuity/gim) || (_oidcKey = oidcKey) != null && _oidcKey.match(/edgenuity/gim) ? AuthSource.IMLP : (_oidcObj5 = oidcObj) != null && (_oidcObj5$authority = _oidcObj5.authority) != null && _oidcObj5$authority.match(/imaginelearning/gim) || (_oidcKey2 = oidcKey) != null && _oidcKey2.match(/imaginelearning/gim) ? AuthSource.ILAuth : null;
    } else {
      var authSourceValue = localStorage.getItem('auth.authSource');
      if (authSourceValue !== null) {
        return authSourceValue != null && authSourceValue.match(/imlp/gim) ? AuthSource.IMLP : authSourceValue != null && authSourceValue.match(/ilauth/gim) ? AuthSource.ILAuth : null;
      }
      return null;
    }
  };
  _proto.checkSessionStorage = function checkSessionStorage() {
    var sessionStorageKeys = Object.keys(sessionStorage);
    var oidcKey = sessionStorageKeys.find(function (key) {
      return key.match(/^oidc./i);
    });
    return oidcKey != null && oidcKey.match(/edgenuity/gim) ? AuthSource.IMLP : oidcKey != null && oidcKey.match(/imaginelearning/gim) ? AuthSource.ILAuth : null;
  };
  _proto.initialize = function initialize() {
    var _this = this;
    var authSource = this.checkAuthSourceParam();
    if (authSource === null) {
      authSource = this.checkSessionStorage();
    }
    if (authSource === null) {
      authSource = this.checkLocalStorage();
    }
    // default to IMLP
    if (authSource === null) {
      authSource = AuthSource.IMLP;
    }
    localStorage.removeItem('auth.authSource');
    if (authSource !== null) {
      localStorage.setItem('auth.authSource', authSource);
    }
    var scopeClaims = authSource === AuthSource.IMLP ? getImlpClaims(this.params.claims) : getIlAuthClaims(this.params.claims);
    var authority = authSource === AuthSource.IMLP ? AUTH_URLS[this.params.environment].imlpApiUrl : AUTH_URLS[this.params.environment].ilAuthApiUrl;
    this.userManager = new UserManager(_extends({}, this.defaultSettings, {
      authority: authority,
      client_id: this.params.client_id,
      scope: scopeClaims.join(' '),
      post_logout_redirect_uri: this.params.post_logout_redirect_uri,
      redirect_uri: this.params.redirect_uri
    }));
    this.userManager.events.addUserUnloaded(function () {
      _this._user = undefined;
      if (!!_this.addUserUnloadedCallback) {
        _this.addUserUnloadedCallback();
      }
    });
  };
  _proto.getUser = function getUser() {
    var _this$userManager;
    return (_this$userManager = this.userManager) == null ? void 0 : _this$userManager.getUser();
  };
  _proto.signinRedirect = function signinRedirect(params) {
    var _this$userManager2;
    if (params === void 0) {
      params = {};
    }
    var encodedState = encodeQueryString(parseQueryString);
    return (_this$userManager2 = this.userManager) == null ? void 0 : _this$userManager2.signinRedirect(encodedState ?
    // Start OAuth redirect
    {
      state: encodedState
    } :
    // No query parameters to store in state
    params);
  };
  _proto.signinRedirectCallback = function signinRedirectCallback() {
    var _this$userManager3,
      _this2 = this;
    return (_this$userManager3 = this.userManager) == null ? void 0 : _this$userManager3.signinRedirectCallback().then(function (oidcUser) {
      _this2._user = oidcUser;
      return oidcUser;
    });
  };
  _proto.signoutRedirect = function signoutRedirect(params) {
    var _this$userManager4,
      _this3 = this;
    if (params === void 0) {
      params = {};
    }
    return (_this$userManager4 = this.userManager) == null ? void 0 : _this$userManager4.signoutRedirect(params).then(function () {
      _this3._user = undefined;
    });
  };
  _proto.signoutRedirectCallback = function signoutRedirectCallback(url) {
    var _this$userManager5,
      _this4 = this;
    return (_this$userManager5 = this.userManager) == null ? void 0 : _this$userManager5.signoutRedirectCallback(url).then(function () {
      _this4._user = undefined;
    });
  };
  _createClass(AuthenticationManager, [{
    key: "user",
    get: function get() {
      return this._user;
    }
  }, {
    key: "token",
    get: function get() {
      var _this$_user;
      return (_this$_user = this._user) == null ? void 0 : _this$_user.access_token;
    }
  }, {
    key: "settings",
    get: function get() {
      var _this$userManager6;
      return (_this$userManager6 = this.userManager) == null ? void 0 : _this$userManager6.settings;
    }
  }]);
  return AuthenticationManager;
}();
function authenticationManager(params) {
  return new AuthenticationManager(params);
}

var ClientId;
(function (ClientId) {
  ClientId["WebGLClient"] = "WebGLClientPKCE";
  ClientId["Portal"] = "PortalPKCE";
  ClientId["WebPortals"] = "WebPortalsPKCE";
})(ClientId || (ClientId = {}));

var UserRoles;
(function (UserRoles) {
  UserRoles["admin"] = "Administrator";
  UserRoles["anonymous"] = "Anonymous";
  UserRoles["ilAdmin"] = "ILAdmin";
  UserRoles["ilSiteAdmin"] = "ILSiteAdmin";
  UserRoles["parent"] = "Parent";
  UserRoles["student"] = "Student";
  UserRoles["teacher"] = "Teacher";
})(UserRoles || (UserRoles = {}));
var UserRole = {
  admin: UserRoles.admin,
  anonymous: UserRoles.anonymous,
  ilAdmin: UserRoles.ilAdmin,
  ilSiteAdmin: UserRoles.ilSiteAdmin,
  parent: UserRoles.parent,
  student: UserRoles.student,
  teacher: UserRoles.teacher
};

var DATE_REGEX = /([0-9]{2,4})-([0-9]{2})-([0-9]{2,4})(?:T([0-9]{2}:[0-9]{2}:[0-9]{2})([\+\-]{1}[0-9]{2}:[0-9]{2}){0,1})*/;
var OverrideStorageKeys = {
  ILE: {
    overrideDate: 'ILE.overrideDate',
    overrideUser: 'ILE.overrideUser'
  },
  Spanish: {
    overrideDate: 'Spanish.overrideDate',
    overrideUser: 'Spanish.overrideUser'
  }
};
var OverrideDate = /*#__PURE__*/function () {
  function OverrideDate() {}
  OverrideDate.getCurrentDate = function getCurrentDate(product) {
    var localDate = new Date().toISOString().substr(0, 10);
    var overrideDate;
    if (product === 'Spanish') {
      overrideDate = localStorage.getItem(OverrideStorageKeys.Spanish.overrideDate);
    } else {
      overrideDate = localStorage.getItem(OverrideStorageKeys.ILE.overrideDate);
    }
    overrideDate = overrideDate && overrideDate.length ? new Date(overrideDate) : undefined;
    return overrideDate ? overrideDate.toISOString().substr(0, 10) : localDate;
  };
  OverrideDate.UseEspanolOverrideDate = function UseEspanolOverrideDate() {
    var _Date;
    localStorage.setItem(OverrideStorageKeys.Spanish.overrideDate, ((_Date = new Date(this.Dates.Spanish)) == null ? void 0 : _Date.toString()) || '');
  };
  OverrideDate.UseLiteracyOverrideDate = function UseLiteracyOverrideDate() {
    var _Date2;
    localStorage.setItem(OverrideStorageKeys.ILE.overrideDate, ((_Date2 = new Date(this.Dates.ILE)) == null ? void 0 : _Date2.toString()) || '');
  };
  OverrideDate.IESetOverrideData = function IESetOverrideData(user) {
    if (!!user.siteCodes && user.siteCodes === 'demo') {
      this.UseEspanolOverrideDate();
      localStorage.setItem(OverrideStorageKeys.Spanish.overrideUser, user.id);
    } else {
      localStorage.removeItem(OverrideStorageKeys.Spanish.overrideDate);
      localStorage.removeItem(OverrideStorageKeys.Spanish.overrideUser);
    }
  };
  OverrideDate.LLSetOverrideData = /*#__PURE__*/function () {
    var _LLSetOverrideData = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(access_token, reportsApiUrl) {
      var user, existingOverride, existingOverrideUser, response, result, date;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            user = new AuthJwt(access_token);
            if (!(user.siteCodes && user.siteCodes === 'demo')) {
              _context.next = 24;
              break;
            }
            existingOverride = localStorage.getItem(OverrideStorageKeys.ILE.overrideDate);
            existingOverrideUser = localStorage.getItem(OverrideStorageKeys.ILE.overrideUser);
            if (!(!existingOverride || existingOverrideUser !== user.id)) {
              _context.next = 22;
              break;
            }
            _context.prev = 5;
            _context.next = 8;
            return fetch(reportsApiUrl + "user/overriddenDate", {
              method: 'GET',
              headers: {
                Authorization: "Bearer " + access_token
              }
            });
          case 8:
            response = _context.sent;
            if (!response.ok) {
              _context.next = 16;
              break;
            }
            _context.next = 12;
            return response.json();
          case 12:
            result = _context.sent;
            if (result) {
              date = result.match(/T/) ? result.split('T')[0] : result;
              localStorage[OverrideStorageKeys.ILE.overrideDate] = new Date(date);
              localStorage[OverrideStorageKeys.ILE.overrideUser] = user.id;
            }
            _context.next = 17;
            break;
          case 16:
            console.error('Failed to fetch overridden date:', response.statusText);
          case 17:
            _context.next = 22;
            break;
          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](5);
            console.error('Error fetching overridden date:', _context.t0);
          case 22:
            _context.next = 26;
            break;
          case 24:
            localStorage.removeItem(OverrideStorageKeys.ILE.overrideDate);
            localStorage.removeItem(OverrideStorageKeys.ILE.overrideUser);
          case 26:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 19]]);
    }));
    function LLSetOverrideData(_x, _x2) {
      return _LLSetOverrideData.apply(this, arguments);
    }
    return LLSetOverrideData;
  }() /* HELPER DATE FUNCTIONS (Copied from cloud-web) */;
  OverrideDate.formatDate = function formatDate(dateStr) {
    var matches = dateStr.match(DATE_REGEX);
    if (matches && matches.length >= 4) {
      var rtnDateStr = matches[1] + '/' + matches[2] + '/' + matches[3] + ' ';
      if (matches.length >= 5) {
        rtnDateStr += matches[4] || '00:00:00';
      } else {
        rtnDateStr += '00:00:00';
      }
      return rtnDateStr;
    }
    return null;
  };
  OverrideDate.parseDate = function parseDate(dateStr) {
    if (!dateStr) {
      return null;
    }
    // Make sure there is a timezone specified. If not, force to UTC.
    if (/(:?[0-9]{2}:){2}[0-9]{2}$/.test(dateStr)) {
      dateStr += 'Z';
    }
    // Try parsing the date string
    var parsedDate = Date.parse(dateStr);
    if (isNaN(parsedDate)) {
      var formattedDate = this.formatDate(dateStr);
      if (!formattedDate) {
        throw new Error('Unable to format date (' + dateStr + ')');
      }
      parsedDate = Date.parse(formattedDate);
      if (isNaN(parsedDate)) {
        throw new Error('Unable to parse date (original: ' + dateStr + ', formatted: ' + formattedDate + ')');
      }
    }
    return new Date(parsedDate);
  };
  return OverrideDate;
}();
OverrideDate.Dates = {
  ILE: 1522382400000,
  Spanish: 1596081600000 // 7/30/2020
};

export { AuthJwt, AuthSource, AuthenticationManager, ClientId, Environment, ILAuthScopeClaims, IMLPScopeClaims, ImpersonationDetails, OverrideDate, OverrideStorageKeys, ScopeClaims, UserRole, UserRoles, accessToken, authenticationManager, getAuthJwt, getCombinedClaims, getIlAuthClaims, getImlpClaims, parsedAccessToken, toEnvironment };
//# sourceMappingURL=web-auth.esm.js.map
